import {Component, OnInit, Input, SimpleChanges, TemplateRef} from "@angular/core";
import { FormControl, FormGroup } from "@angular/forms";
import { DomSanitizer, SafeResourceUrl } from "@angular/platform-browser";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { SharedService } from "src/app/core/services/shared.service";
import Swal from "sweetalert2";

@Component({
  selector: "report-viewer",
  templateUrl: "./report-viewer.component.html",
  styleUrls: ["./report-viewer.component.scss"],
})
export class ReportViewerComponent implements OnInit {
  razones = [];
  safeURL: SafeResourceUrl;
  formFirma: FormGroup;
  CNT05COD = null;

  // Data del Reporte en Base64
  @Input() ReportData: any = null;
  @Input() tipoDocumento: any;
  @Input() firmar = false;

  // URL del Reporte
  @Input() strRptUrl: string = "";
  @Input() Llaves: any;

  constructor(
    private sanitizer: DomSanitizer,
    private dataService: SharedService,
    private modalService: NgbModal
  ) {}

  VerReporte() {
    let strjson =
      '{    "FILTROS_OPCIONALES"   : []' +
      ' , "SYS02CON"   : "" ' +
      ' , "SYS10CON"   : ' +
      0 +
      ' , "FORMATO"    : "" ' +
      ' , "TSTAMP"     : ' +
      0 +
      ' , "TITULO"     : ""' +
      ' , "FILTROS_DASHBOARD"    : [] ' +
      ' , "FILTROS_OBLIGATORIOS" : ' +
      JSON.stringify(this.Llaves) +
      "}";

    let arr = JSON.parse(strjson);
    let json = this.toJSON("ABRIR_REPORTE_PDF", arr, this.strRptUrl, "");

    this.dataService.ConsultarWS(this.strRptUrl, json).subscribe( datosResp => {
        this.ReportData = datosResp.DATA[0].REPORTE_PDF_BASE64;
        const blob = this.base64ToBlob( this.ReportData, 'application/pdf' );
        const url = URL.createObjectURL( blob );
        this.safeURL = this.sanitizer.bypassSecurityTrustResourceUrl(url);
      },
      (error) => {
        this.ReportData = null;
        Swal.fire({
          title: "Error",
          text: error,
          icon: "error",
        });
      }
    );
  }

  toJSON(
    operacion: string,
    arr: any,
    url?: string,
    titulo?: string,
    extra?: any
  ) {
    let NavID = (
      Date.now().toString(36) + Math.random().toString(36).substr(2, 5)
    ).toUpperCase();
    return JSON.parse(
      '{ "LLAVES"   :' +
        JSON.stringify(arr) +
        (url != null ? ', "URL"      :"' + url + '"' : "") +
        (titulo != null ? ', "TITULO"      :"' + titulo + '"' : "") +
        (extra != null ? "," + extra : "") +
        ', "NAV_ID"   : "' +
        NavID +
        '"' +
        ', "OPERACION": "' +
        operacion +
        '"}'
    );
  }

  ngOnInit(): void {
    this.formFirma = new FormGroup({
      suscriptor: new FormControl(),
      razon: new FormControl(),
      lugar: new FormControl("Avatarsys"),
      resumen: new FormControl(),
    });
    this.CNT05COD = localStorage.getItem("X-AVATAR-CNT05COD");

    if (this.strRptUrl != "") {
      this.VerReporte();
    } else {  
      const blob = this.base64ToBlob( this.ReportData, 'application/pdf' );
      const url = URL.createObjectURL( blob );
      this.safeURL = this.sanitizer.bypassSecurityTrustResourceUrl(url);
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.ReportData != undefined) {
      const blob = this.base64ToBlob( this.ReportData, 'application/pdf' );
      const url = URL.createObjectURL( blob );
      this.safeURL = this.sanitizer.bypassSecurityTrustResourceUrl(url);
    }
  }

  abrirModal(contenido: TemplateRef<any>) {
    let jsonReq = { CNT05COD: this.CNT05COD };
    this.dataService
      .ConsultarWS("api/ws/gaudi/modalFirma", JSON.stringify(jsonReq))
      .subscribe(
        (datosResp: any) => {
          this.razones = datosResp.razones;
          this.formFirma.get("lugar").setValue(datosResp.lugar);
          this.modalService.open(contenido, { size: "xl" });
        },
        (error) => {
          Swal.fire({
            title: "Error",
            text: error,
            icon: "error",
          });
        }
      );
  }

  onSubmit() {
    let jsonDoc = this.formFirma.value;
    jsonDoc.CNT05COD = this.CNT05COD;
    jsonDoc.DOCUMENTO = this.ReportData;

    this.dataService
      .ConsultarWS("api/ws/gaudi/firmarPDF", JSON.stringify(jsonDoc))
      .subscribe(
        (datosResp: any) => {
          this.modalService.dismissAll();
          if (datosResp.codigoError == 0) {
            Swal.fire({
              html:
                '<div class="row align-items-center" style="width:100%; overflow:auto;"> ' +
                '<div class="col-5">' +
                ' <img src="assets/images/Icon_Alerta-InformacionAvatar-SyS.png" width="160px"> </img>' +
                "</div>" +
                ' <div class="col-7">' +
                "<h4>Solicitud realizada</h4><br>" +
                "<p>Documento en proceso de firmado con código de verificación: </p> <h4>" +
                datosResp.codigoVerificacion +
                " </h4></div> ",
            });
          } else {
            Swal.fire({
              html:
                '<div class="row align-items-center" style="width:100%; overflow:auto;"> ' +
                '<div class="col-5">' +
                ' <img src="assets/images/imageerror.png"> </img>' +
                "</div>" +
                ' <div class="col-7">' +
                "<h3>Error</h3><br>" +
                " <h4>Código de error: " +
                datosResp.codigoError +
                "</h4>" +
                " </div> ",
            });
          }
        },
        (error) => {
          Swal.fire({
            html:
              '<div class="row align-items-center" style="width:100%; overflow:auto;"> ' +
              '<div class="col-5">' +
              ' <img src="assets/images/imageerror.png"> </img>' +
              "</div>" +
              ' <div class="col-7">' +
              "<h3>Error</h3><br>" +
              " <p>" +
              error +
              "</p>" +
              " </div> ",
          });
        }
      );
  }

  base64ToBlob(base64, type = "application/octet-stream") {
    const byteString = window.atob(base64);
    const arrayBuffer = new ArrayBuffer(byteString.length);
    const int8Array = new Uint8Array(arrayBuffer);
    for (let i = 0; i < byteString.length; i++) {
      int8Array[i] = byteString.charCodeAt(i);
    }
    const blob = new Blob([int8Array], { type: type });
    return blob;
  }
}
